<div class="language-switcher">
  <button
    class="language-dropdown-trigger"
    (click)="toggleDropdown()"
    [attr.aria-label]="'LANGUAGE.SELECT' | translate"
  >
    <span class="language-flag">{{ getLanguageFlag(languageService.currentLanguage$ | async) }}</span>
    <span class="language-label">{{ getLanguageLabel(languageService.currentLanguage$ | async) }}</span>
    <span class="dropdown-arrow">▼</span>
  </button>

  <div class="language-dropdown" *ngIf="isDropdownOpen">
    <button
      *ngFor="let lang of languageService.availableLanguages"
      [class.active]="lang === (languageService.currentLanguage$ | async)"
      (click)="onLanguageChange(lang)"
      class="language-option"
    >
      <span class="language-flag">{{ getLanguageFlag(lang) }}</span>
      <span class="language-label">{{ getLanguageLabel(lang) }}</span>
    </button>
  </div>
</div>
